import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { GuidePanel } from "../components/guide/GuideSystem";
import * as Legacy from "../app/runtime";

const { http, setAuthFromResponse, getErr, C, CSS, BrandLogo, Btn, Input, Card } = Legacy;

export const InitialSetupPage = () => {
  const nav = useNavigate();
  const [checking, setChecking] = useState(true);
  const [setupRequired, setSetupRequired] = useState(false);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "", confirmPassword: "" });
  const set = (key: keyof typeof form) => (value: string) => setForm((current) => ({ ...current, [key]: value }));

  useEffect(() => {
    http.get("/setup/status")
      .then((res) => {
        const required = Boolean(res.data?.data?.setupRequired);
        setSetupRequired(required);
        if (!required) nav("/login", { replace: true });
      })
      .catch((e: any) => setErr(getErr(e)))
      .finally(() => setChecking(false));
  }, [nav]);

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: `linear-gradient(135deg,${C.soft},${C.bg})`, padding: 20 }}>
      <style>{CSS}</style>
      <Card style={{ width: "100%", maxWidth: 520, borderRadius: 28, padding: 30, boxShadow: "0 26px 70px rgba(122,78,58,0.16)" }}>
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 18 }}><BrandLogo size={76} compact /></div>
        <GuidePanel pageKey="initial-setup" compact />
        <h1 style={{ margin: "0 0 8px", fontSize: 24, fontWeight: 900, color: C.text }}>Create Initial Owner</h1>
        <p style={{ margin: "0 0 22px", fontSize: 13, lineHeight: 1.65, color: C.mid }}>This secure setup appears only when the database has zero users. The first account becomes the active Owner.</p>
        {err && <div style={{ background: "#FDEAEA", borderRadius: 10, padding: "10px 14px", marginBottom: 16, fontSize: 13, color: C.danger }}>{err}</div>}
        {checking ? <div style={{ color: C.mid, fontSize: 13 }}>Checking setup status...</div> : setupRequired && (
          <form onSubmit={async (event) => {
            event.preventDefault();
            setErr("");
            setLoading(true);
            try {
              await http.post("/setup/initial-owner", form);
              const r = await http.post("/auth/login", { email: form.email, password: form.password });
              setAuthFromResponse(r.data.data);
              nav("/dashboard", { replace: true });
            } catch (e: any) {
              setErr(getErr(e));
            } finally {
              setLoading(false);
            }
          }}>
            <Input label="Owner Name" value={form.name} onChange={set("name")} required />
            <Input label="Owner Email" value={form.email} onChange={set("email")} type="email" required />
            <Input label="Phone" value={form.phone} onChange={set("phone")} />
            <Input label="Password" value={form.password} onChange={set("password")} type="password" required />
            <Input label="Confirm Password" value={form.confirmPassword} onChange={set("confirmPassword")} type="password" required />
            <div style={{ background: C.soft, borderRadius: 12, padding: "10px 14px", marginBottom: 16, fontSize: 12, color: C.primary, lineHeight: 1.5 }}>Use a unique password with uppercase, lowercase, number, and symbol. Shared or default passwords are blocked.</div>
            <Btn full loading={loading}>Create Owner Account</Btn>
          </form>
        )}
      </Card>
    </div>
  );
};

export default InitialSetupPage;
